/* eslint-disable react/prop-types */
import React from 'react';

import { useFeedContext } from '../../../Context/index.tsx';
import StepOne from '../Steps/Step1/StepOne.js';
import Final from '../Steps/Step3/Final.js';
import QuestionnaireForm from '../Steps/Step2/QuestionForm/QuestionForm.js';

function AdQuiz() {
    const { step } = useFeedContext();

    switch (step) {
        case 1:
            return (
                <>
                    <StepOne type="quiz" />
                </>
            );
        case 2:
            return (
                <>
                    <QuestionnaireForm feedtype="quiz" />
                    {/* <LongPoll type="quiz" /> */}
                </>
            );
        case 3:
            return (
                <>
                    <Final type="quiz" />
                </>
            );
        default:
            return <></>;
    }
}

export default AdQuiz;
